import { notification } from 'antd'
import { getAxios } from '../../axiosWithToken'

export const postRegisterRace = (body) => {
  const copyBody = body
  copyBody.email = copyBody.username
  copyBody.selected_shirt = [
    ...copyBody.selected_shirt,
    ...(copyBody.selected_undershirt || []),
    ...(copyBody.selected_buff || []),
    ...(copyBody.selected_v_shirt || []),
    ...(copyBody.selected_keychain || []),
    ...(copyBody.selected_1 || []),
    ...(copyBody.selected_2 || []),
    ...(copyBody.selected_3 || []),
    ...(copyBody.selected_4 || []),
    ...(copyBody.selected_5 || []),
    ...(copyBody.selected_6 || []),
    ...(copyBody.selected_7 || []),
    ...(copyBody.selected_8 || []),
    ...(copyBody.selected_9 || []),
    ...(copyBody.selected_10 || []),
    ...(copyBody.selected_11 || []),
    ...(copyBody.selected_12 || []),
    ...(copyBody.selected_13 || []),
    ...(copyBody.selected_14 || []),
    ...(copyBody.selected_15 || []),
    ...(copyBody.selected_16 || []),
    ...(copyBody.selected_17 || []),
    ...(copyBody.selected_18 || []),
    ...(copyBody.selected_19 || []),
    ...(copyBody.selected_20 || []),
    ...(copyBody.selected_21 || []),
    ...(copyBody.selected_22 || []),
    ...(copyBody.selected_23 || []),
    ...(copyBody.selected_24 || []),
    ...(copyBody.selected_25 || []),
  ]
  copyBody.selected_shirt = copyBody.selected_shirt.filter((i) => i)
  return getAxios()
    .post(`participants/`, copyBody)
    .catch((e) => {
      notification.error({
        message: Object.entries(e.response.data)
          .map((x) => x.join(':'))
          .join('\r\n'),
      })
      return Promise.reject(e)
    })
}

export const postOrder = (body) => {
  const copyBody = body

  copyBody.selected_shirt = [
    ...copyBody.selected_shirt,
    ...(copyBody.selected_undershirt || []),
    ...(copyBody.selected_buff || []),
    ...(copyBody.selected_v_shirt || []),
    ...(copyBody.selected_keychain || []),
    ...(copyBody.selected_1 || []),
    ...(copyBody.selected_2 || []),
    ...(copyBody.selected_3 || []),
    ...(copyBody.selected_4 || []),
    ...(copyBody.selected_5 || []),
    ...(copyBody.selected_6 || []),
    ...(copyBody.selected_7 || []),
    ...(copyBody.selected_8 || []),
    ...(copyBody.selected_9 || []),
    ...(copyBody.selected_10 || []),
    ...(copyBody.selected_11 || []),
    ...(copyBody.selected_12 || []),
    ...(copyBody.selected_13 || []),
    ...(copyBody.selected_14 || []),
    ...(copyBody.selected_15 || []),
    ...(copyBody.selected_16 || []),
    ...(copyBody.selected_17 || []),
    ...(copyBody.selected_18 || []),
    ...(copyBody.selected_19 || []),
    ...(copyBody.selected_20 || []),
    ...(copyBody.selected_21 || []),
    ...(copyBody.selected_22 || []),
    ...(copyBody.selected_23 || []),
    ...(copyBody.selected_24 || []),
    ...(copyBody.selected_25 || []),
  ]
  copyBody.selected_shirt = copyBody.selected_shirt.filter((i) => i)
  copyBody.event = copyBody.event.id
  return getAxios()
    .post(`orders/`, copyBody)
    .catch((e) => {
      notification.error({
        message: Object.entries(e.response.data)
          .map((x) => x.join(':'))
          .join('\r\n'),
      })
      return Promise.reject(e)
    })
}

export const patchRegisterRace = (body, participantId) => {
  const copyBody = body
  copyBody.selected_shirt = [
    ...copyBody.selected_shirt,
    ...(copyBody.selected_undershirt || []),
    ...(copyBody.selected_buff || []),
    ...(copyBody.selected_v_shirt || []),
    ...(copyBody.selected_keychain || []),
    ...(copyBody.selected_1 || []),
    ...(copyBody.selected_2 || []),
    ...(copyBody.selected_3 || []),
    ...(copyBody.selected_4 || []),
    ...(copyBody.selected_5 || []),
    ...(copyBody.selected_6 || []),
    ...(copyBody.selected_7 || []),
    ...(copyBody.selected_8 || []),
    ...(copyBody.selected_9 || []),
    ...(copyBody.selected_10 || []),
    ...(copyBody.selected_11 || []),
    ...(copyBody.selected_12 || []),
    ...(copyBody.selected_13 || []),
    ...(copyBody.selected_14 || []),
    ...(copyBody.selected_15 || []),
    ...(copyBody.selected_16 || []),
    ...(copyBody.selected_17 || []),
    ...(copyBody.selected_18 || []),
    ...(copyBody.selected_19 || []),
    ...(copyBody.selected_20 || []),
    ...(copyBody.selected_21 || []),
    ...(copyBody.selected_22 || []),
    ...(copyBody.selected_23 || []),
    ...(copyBody.selected_24 || []),
    ...(copyBody.selected_25 || []),
  ]
  copyBody.selected_shirt = copyBody.selected_shirt.filter((i) => i)
  return getAxios()
    .patch(`participants/${participantId}`, copyBody)
    .catch((e) => {
      notification.error({
        message: Object.entries(e.response.data)
          .map((x) => x.join(':'))
          .join('\r\n'),
      })
      return Promise.reject(e)
    })
}

export const getGroupByRace = (raceId) =>
  getAxios().get(`races/group/?race=${raceId}`)

export const getSumDistanceGroupByRace = (raceId) =>
  getAxios().get(`races/sum-distance-group/${raceId}`)

export const getMyMedal = () => getAxios().get('races/my-medal/')



// WEBPACK FOOTER //
// /opt/build/repo/src/api/sync/races/index.js